import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AutoCompleteModule } from "@bfx/primeng/autocomplete";
import { CalendarModule } from "@bfx/primeng/calendar";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { InputTextModule } from "@bfx/primeng/inputtext";
import { PanelModule } from "@bfx/primeng/panel";
import { SliderModule } from "@bfx/primeng/slider";
import { TriStateCheckboxModule } from "@bfx/primeng/tristatecheckbox";
import { BfxAutoCompleteComponent } from "./bfx-autocomplete.component";
import { BfxCheckboxIconSmallComponent } from "./bfx-checkbox-icon-small.component";
import { BfxFocusEditableDirective } from "./bfx-focus-editable.directive";
import { BfxHorizontalPanelComponent } from "./bfx-horizontal-panel.component";
import { BfxMultiSelectorComponent } from "./bfx-multi-selector.component";
import { BfxMultiSelectorService } from "./bfx-multi-selector.service";
import { BfxProgressBarComponent } from "./bfx-progressbar.component";
import { BfxToogleComponent } from "./bfx-toggle.component";
import { BfxTooltipDirective } from "./bfx-tooltip.directive";
import { BfxTristateIconStarComponent } from "./bfx-tristate-icon-star.component";
import { ICAlgoTypeDefaultsComponent } from "./ic-algo-type-defaults.component";
import { ICPrivateOrderDefaultsComponent } from "./ic-private-order-defaults.component";
import { ICAutocompleteDefaultsComponent } from "./ic-autocomplete-defaults.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { ICCcyPairDefaultsComponent } from "./ic-ccy-pair-defaults.component";
import { BfxInputMaskComponent } from "./bfx-inputmask.component";
import { BfxTimeEditComponent } from "./bfx-time-edit.component";
import { ICPriceSpinnerComponent } from "./ic-price-spinner.component";
import { ICBulkEditCheckboxComponent } from "./ic-bulk-edit-checkbox.component";
import { BfxCommentWarning } from "./bfx-comment-warning";
import { BaseComponentsModule } from "shared/base-components/base-components.module";
import { AutoHedgeStatusComponent } from "./auto-hedge-status.component";
import { BfxPipeModule } from "../bfx-shared/bfx-pipes.module";
import { BfxCalloutComponent } from "app/bfx-element-library/bfx-callout.component";
import { BfxQuickSearchComponent } from "app/bfx-element-library/bfx-quick-search.component";

@NgModule({
  imports: [
    AutoCompleteModule,
    CalendarModule,
    CheckboxModule,
    CommonModule,
    FormsModule,
    PanelModule,
    SliderModule,
    TriStateCheckboxModule,
    FlexLayoutModule,
    InputTextModule,
    BaseComponentsModule,
    BfxPipeModule,
  ],
  declarations: [
    BfxAutoCompleteComponent,
    BfxCheckboxIconSmallComponent,
    BfxTristateIconStarComponent,
    BfxFocusEditableDirective,
    BfxHorizontalPanelComponent,
    BfxMultiSelectorComponent,
    BfxProgressBarComponent,
    BfxToogleComponent,
    BfxTooltipDirective,
    ICPrivateOrderDefaultsComponent,
    ICAlgoTypeDefaultsComponent,
    ICAutocompleteDefaultsComponent,
    ICCcyPairDefaultsComponent,
    BfxInputMaskComponent,
    BfxTimeEditComponent,
    ICPriceSpinnerComponent,
    ICBulkEditCheckboxComponent,
    BfxCommentWarning,
    AutoHedgeStatusComponent,
    BfxCalloutComponent,
    BfxQuickSearchComponent,
  ],
  providers: [BfxMultiSelectorService],
  exports: [
    BfxAutoCompleteComponent,
    BfxCheckboxIconSmallComponent,
    BfxTristateIconStarComponent,
    BfxFocusEditableDirective,
    BfxHorizontalPanelComponent,
    BfxProgressBarComponent,
    BfxToogleComponent,
    BfxTooltipDirective,
    ICPrivateOrderDefaultsComponent,
    ICAlgoTypeDefaultsComponent,
    ICAutocompleteDefaultsComponent,
    ICCcyPairDefaultsComponent,
    BfxInputMaskComponent,
    BfxTimeEditComponent,
    ICPriceSpinnerComponent,
    ICBulkEditCheckboxComponent,
    BfxCommentWarning,
    AutoHedgeStatusComponent,
    BfxCalloutComponent,
    BfxQuickSearchComponent,
  ],
})
export class BfxElementsLibraryModule {}
